import React, { Component } from "react";
import { Select } from "@rocketseat/unform";

import api from "../../../services/api";

export default class OperadoresField extends Component {
  /**
   * Retorna um SELECT com os operadores
   */
  state = {
    options: [{ id: 0, title: "Selecione" }]
  };

  async componentDidMount() {
    // Carregar os operadores
    await api
      .get("/pasta/users/")
      .then(response => {
        const options = [...this.state.options];
        const usuarios = response.data;

        usuarios.map(user =>
          options.push({ id: user.id, title: user.username })
        );

        this.setState({
          options
        });
      })
      .catch(error => {
        console.log("Falha ao carregar os operadores. ", error);
      });
  }

  render() {
    return (
      <Select name="operador" options={this.state.options} {...this.props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Acordo/OperadoresField/index.js